import { modifier } from "ember-modifier"
import { each } from "lodash-es"

export default modifier((element: HTMLElement, [selector = "a"]: any) => {
  let childElements = element.querySelectorAll(selector)

  each(childElements, (element) => {
    element.setAttribute("target", "_blank")
  })
})
